var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-3 justify-center provider-card",attrs:{"title":_vm.provider.name}},[_c('div',{staticClass:"w-full",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"w-full h-full relative"},[_c('img',{staticClass:"w-full h-full",attrs:{"src":_vm.displayImage,"alt":_vm.provider.name}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }